import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { GridActionsCellItem } from '@mui/x-data-grid';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import { deleteUser, users_data } from 'http/components/UserService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { SetUsersData } from 'Utils/Helpers/HandleApiData';
import { useSelector, useDispatch } from 'react-redux';
import { read } from 'Utils/Helpers/LocalStorage';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DeleteUser({ cell, row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [semi, setSemi] = useState(false);
  const [force, setForce] = useState(false);
  const { current } = useSelector((state) => ({
    current: state.staff.current,
  }));
  const setShowDialog = () => {
    setShow(true);
  }
  const handleClose= () => {
    setShow(false);
  }

  const onEnter = () => {
    setSemi(false);
  }

  const onFinish = async () => {
    dispatch(HandleLoading(true));
    const response = await deleteUser(row.id, force);
    if(response.status) {
      const response2 = await users_data();
      if(response2.status) {
          await dispatch(SetUsersData(response2.data))
      } else {
        dispatch(HandleLoading(false));
      }
    } else {
      dispatch(HandleLoading(false));
    }
    setShow(false);
  }

  return (
    <>
      <GridActionsCellItem
        icon={<icons.Trash3 size={16} />}
        label="Delete"
        onClick={setShowDialog}
        className={row.id === read('local') ? 'd-none' : ''}
        disabled={!current[3][4]}
        hidden={!current[3][4]}
      />
      {
        show &&
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xs'}
          onClose={handleClose}
          TransitionProps={{onEnter: onEnter}}
          aria-describedby="alert-dialog-slide-appointment-edit"
        >
          <DialogTitle className='delete-mode'>
            {`حذف کاربر ${row.name.substring(0, row.name.indexOf(" "))}`}
            <div className='close-btn' onClick={handleClose}>
              <icons.X/>
            </div>
          </DialogTitle>
          <DialogContent>
            {
              (show && !semi) ?
              <DialogContentText id="alert-dialog-slide-appointment-edit">
                <div className='delete-body'>
                  <div className='content'>
                    <p>
                      {'از حذف کاربر با مشخصات زیر اطمینان دارید ؟'}
                    </p>
                    <div className='details'>
                      <p>
                        {"نام :"}
                        {" "}
                        <strong>{row.name}</strong>
                      </p>
                      <p>
                        {"موبایل :"}
                        {" "}
                        <strong>{row.mobile}</strong>
                      </p>
                    </div>
                  </div>
                  <div className='border-top mt-1 p-2'>
                    <FormControlLabel
                      key={`force_delete_user`}
                      control={<Checkbox 
                        checked={force}
                        onChange={() => setForce(!force)}
                      />}
                      label={"حذف اجباری کاربر"}
                    />
                    {
                      force &&
                      <>
                        <p className='px-3 text-danger'>
                          <strong>
                            {"در نظر داشته باشید که :"}
                          </strong>
                        </p>
                        <p className='px-3 text-danger'>
                          {"با انتخاب گزینه حذف اجباری، تمامی "}
                          <strong>{"نوبت‌ها، وضعیت‌ها، پرداخت‌ها "}</strong>
                          {"و همچنین "}
                          <strong>{"بیماران "}</strong>
                          {"ثبت شده توسط این کاربر نیز حذف خواهند شد. در انتخاب آن دقت فرمایید."}
                        </p>
                      </>
                    }
                  </div>
                </div>
              </DialogContentText> : <p className='mb-1'>
                  {"آیا از حذف مطمئن هستید ؟"}
                </p>
            }
          </DialogContent>
          <DialogActions>
            {
              semi
              ? <div className='w-100 flex-row-center-center'>
                <CButton
                  text={'خیر'}
                  icon={<icons.XLg/>}
                  onClick={handleClose}
                  action=''
                  className={'ms-2'}
                />
                <CButton
                  text={'بله'}
                  icon={<icons.Trash3/>}
                  onClick={onFinish}
                  action='delete'
                />
              </div>
              : <CButton
                text={'حذف کاربر'}
                icon={<icons.Trash3/>}
                onClick={() => setSemi(true)}
                action='delete'
              />
            }
          </DialogActions>
        </Dialog>
      }
    </>
  );
}
